module.exports = __webpack_public_path__ + "static/media/screenshots - iPhone 6.48c88059.png";